import React, { useEffect, useState, useContext  } from "react"
import Flatpickr from "react-flatpickr";

import {
  Col,
  Row,
  Card,
  CardBody,
  Container,
  Label,
  Input,
  InputGroup,
  Form,
  FormFeedback,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Spinner,
  CardFooter
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik";

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import { CreateCorporateGovernanceFile, GetCorporateGovernanceFileById, UpdateCorporateGovernanceFile } from "services/api/module/CorporateGovernanceFile"
import ModalContext from "../../contexts/ModalContext";
import UploadFileAPI from "components/UploadFileAPI"
import InputLang from "components/Input/InputLang";
import moment from "moment";
import MyEditor from "components/MyEditor";
import UploadFileS3 from "components/UploadFileS3";
import InputAttachment from "components/Input/attachment/InputAttachment";
import PopupAttachment from "components/Input/attachment/PopupAttachment";
import UploadDesc from "components/UploadDesc";
import { ReactSortable } from 'react-sortablejs';
import Sortable from "sortablejs"
import InputText from "components/Input/InputText";
import Error401 from "components/Error401";

const STATUS_OPTION = fn_helper.OPTIONS.STATUS_NO_DELETE
const _routePermission = `corporate-governance:corporate-governance-file`

const CorporateGovernanceFileTemplate = ({
  pageView = "create"
}) => {
  // POPUP
  const { mAlert } = useContext(ModalContext);

  // OTHER STATE
  const qParams = useParams()
  const qLang = _.upperCase(qParams?.lang) ?? 'TH'
  const qMainId = qParams.id
  const navigate = useNavigate();

  // ========== Form Validation ========== //
  const validationSchema = Yup.object({
    contentSubject: Yup.string().max(255).required("Please Enter Filename"),
    // contentDetail: Yup.string().max(255).required("Please Enter รายละเอียด"),

    // contentSeoTitle: Yup.string().required("Please Enter Meta Title"),
    // contentSeoKeyword: Yup.string().max(1024).required("Please Enter Meta keyword"),
    // contentSeoDescription: Yup.string().max(1024).required("Please Enter Meta Description"),
    contentUpdateDate: Yup.string().max(100).required("Please Select Written at"),
    contentStatus: Yup.string().max(100).required("Please Enter Display"),


  })
  

  // LOCAL STATE FORM
  const [updatedValidationSchema, setUpdatedValidationSchema] = useState(validationSchema)

  const initialValues = {
    contentId: "",

    // Content
    contentSubject: "",
    // contentDetail: "",
    contentThumbnail: {},
    contentFile: {},

    contentSeoTitle: "",
    contentSeoKeyword: "",
    contentSeoDescription: "",
    contentUpdateDate: moment().format('YYYY-MM-DD'),
    contentStatus: "active",


  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: updatedValidationSchema,
    onSubmit: values => {
      console.log("🚀 ~ CorporateGovernanceFileCreate ~ values:", values)
      const payload = {
        id: qMainId ? qMainId : undefined,
        contentId: values.contentId ? values.contentId: undefined,
        langId: qLang,
        contentSubject: values.contentSubject,

        contentSeoTitle: values.contentSeoTitle,
        contentSeoKeyword: values.contentSeoKeyword,
        contentSeoDescription: values.contentSeoDescription,
        contentUpdateDate: values.contentUpdateDate,
        contentStatus: values.contentStatus,

        attachmentData: {

        },

        contentAttachmentData: {
          thumbnail: values.contentThumbnail,
          file: values.contentFile,
        }
      };
      console.log("🚀 ~ onSave ~ payload:", payload);

      if (pageView === "update") {
        API.fetchUpdateCorporateGovernanceFile(payload)
      } else {
        API.fetchCreateCorporateGovernanceFile(payload)
      }
    },
  })

  const preFilInput = (resData = {}) => {
    console.log("🚀 ~ preFilInput ~ resData:", resData)
    // resetForm(validation.values, initialValues)

    // ถ้าไม่หน่วงมันจะแย่งกันทำ
    validation.setFieldValue("contentId", resData?.contentId ?? "")
    validation.setFieldValue("contentSubject", resData?.contentSubject ?? "")
    // validation.setFieldValue("contentDetail", resData?.contentDetail ?? "")
    validation.setFieldValue("contentFile", resData?.contentFile ?? "")
    validation.setFieldValue("contentThumbnail", resData?.contentThumbnail ?? "")
    
    // validation.setFieldValue("contentSeoTitle", resData?.contentSeoTitle ?? "")
    // validation.setFieldValue("contentSeoKeyword", resData?.contentSeoKeyword ?? "")
    // validation.setFieldValue("contentSeoDescription", resData?.contentSeoDescription ?? "")
    validation.setFieldValue("contentUpdateDate", resData?.contentUpdateDate ?? moment().format('YYYY-MM-DD'))
    validation.setFieldValue("contentStatus", resData?.contentStatus ?? "active")

  }

  const API = {
    fetchGetCorporateGovernanceFileById: async (payload) => {
      try {
          const response = await GetCorporateGovernanceFileById({ id: payload.id, lang: qLang })
          const resData = response.data
          if (resData.status == 200) {
            preFilInput(resData.data)
          }
      }
      catch (err) {
          console.log('err ', err)
          mAlert.info({
            title: "Alert",
            subTitle: "Something went wrong",
            content: "",
            onClose: () => {
            //  alert("onClose")
            },
        })
      }
    },
    fetchCreateCorporateGovernanceFile: async (payload) => {
      try {
          const response = await CreateCorporateGovernanceFile({ data: payload, lang: qLang })
          const resData = response.data
          if (resData.status == 201) {
            mAlert.info({
                title: "Alert",
                subTitle: "Created Data Success",
                content: "",
                onClose: () => {
                  navigate(`/corporate-governance/${qLang}/file`)
                },
            })
          }
      } catch (e) {
          console.log(e)
          mAlert.info({
              title: "Alert",
              subTitle: "Something went wrong",
              content: "",
              onClose: () => {
              //  alert("onClose")
              },
          })
      }
    },
    fetchUpdateCorporateGovernanceFile: async (payload) => {
      try {
          const response = await UpdateCorporateGovernanceFile({ data: payload, id: payload.id, lang: qLang })
          const resData = response.data
          if (resData.status == 202) {
              mAlert.info({
                  title: "Alert",
                  subTitle: "Update Data Success",
                  content: "",
                  onClose: () => {
                    navigate(`/corporate-governance/${qLang}/file`)
                  },
              })
          }
      }
      catch (err) {
          console.log('err ', err)
          mAlert.info({
              title: "Alert",
              subTitle: "Something went wrong",
              content: "",
              onClose: () => {
              //  alert("onClose")
              },
          })
      }
    }
  }

  // กรณี Edit
  useEffect(() => {
    if (["update", "view"].includes(pageView)) {
      const payload = { id : qMainId }
      API.fetchGetCorporateGovernanceFileById(payload)
    }
  }, [qLang])

  const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
  document.title = `Corporate Governance File | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE

  const itemStyle = {
    padding: '10px',
    border: '1px solid black',
    margin: '5px',
    borderRadius: '8px',
    background: '#f9f9f9',
    transition: 'transform 0.2s ease, background-color 0.3s ease',
  };

  const mapValues = (list = []) => list.map(item => {
    const newObj = {
      attachmentId: item.attachmentId,
      sequence: item.sequence
    }
    return newObj
  })  
  
  if(!checkScope(`${_routePermission}:create`) || !checkScope(`${_routePermission}:update`) || !checkScope(`${_routePermission}:view`)) {
    return <Error401 />
  }

  return (
      <React.Fragment>
          <div className="page-content">
            <Container fluid>
                {/* Render Breadcrumb */}
                <Breadcrumbs
                  title={`${PAGE_VIEW} Corporate Governance File`}
                  breadcrumbItems={[
                    { title: "CorporateGovernance File", link: "" },
                    { title: PAGE_VIEW },
                  ]}
                />
    
                {/* Render Form */}
                <Row>
                  <Col className="col-12">
                  <FormikProvider value={validation}>
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                      }}
                    >
                      <Row>
                          <Col className="col-8">
                            <Card>
                              <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                <i className='bx bx-cube-alt'></i> Information Box
                              </h5>
                              <CardBody>
                              <Row>
                                <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                  >
                                    Filename
                                    <span className="t-require">*</span>
                                  </label>
                                  <div className="col-md-12">
                                    <InputText
                                      id="contentSubject"
                                      className="form-control"
                                      type="text"
                                      placeholder=""
                                      name="contentSubject"
                                    
                                      onChange={(e) => {
                                        validation.setFieldValue("contentSubject", e.target.value)
                                      }}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.contentSubject}
                                      invalid={validation.touched.contentSubject && validation.errors.contentSubject ? true : false}
                                      disabled={pageView === "view"}
                                      maxLength={9999}
                                      errorText={validation.errors.contentSubject}
                                    />
                                  </div>
                                </Col>
                                {/* <Col className="col-12 mb-3">
                                  <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                  >
                                    รายละเอียด
                                    <span className="t-require">*</span>
                                  </label>
                                  <div className="col-md-12">
                                    <Input
                                      id="contentDetail"
                                      className="form-control"
                                      type="textarea"
                                      rows="3"
                                      placeholder=""
                                      name="contentDetail"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.contentDetail}
                                      invalid={ validation.touched.contentDetail && validation.errors.contentDetail ? true: false}
                                      disabled={pageView === "view"}
                                    />
                                    { 
                                      validation.touched.contentDetail && validation.errors.contentDetail && (
                                        <FormFeedback type="invalid">
                                          {validation.errors.contentDetail}
                                        </FormFeedback>
                                      )
                                    }
                                  </div>
                                </Col> */}
                                <Col className="col-12 mb-3">
                                {/* {JSON.stringify(validation.values.contentThumbnail)} */}
                                  <div className="col-md-12">
                                    <PopupAttachment
                                      typeDetail="single"
                                      typeUpload="ImageMap"
                                      upload="Image"
                                      prefixName="brand-image"
                                      label="Thumbnail"
                                      required={true}
                                      description="description"
                                      widthSize={261}
                                      heightSize={363}
                                      value={validation.values.contentThumbnail}
                                      onChange={(value = {}, index) => {
                                        console.log("🚀 onChange ~ value:", value)
                                        console.log("🚀 onChange ~ index:", index)
                                        validation.setFieldValue('contentThumbnail', value)
                                      }}
                                      onRemove={(index) => {
                                        console.log("🚀 onChange ~ index:", index)
                                        validation.setFieldValue('contentThumbnail', {})
                                      }}
                                    />
                                    {validation.touched.contentThumbnail && validation.errors.contentThumbnail && (
                                      <div type="invalid"className="invalid-feedback d-block">
                                        {validation.errors.contentThumbnail}
                                      </div>
                                    )}
                                  </div>
                                  <hr/>
                                </Col>
                                <Col className="col-12 mb-3">
                                {/* {JSON.stringify(validation.values.contentThumbnail)} */}
                                  <div className="col-md-12">
                                    <PopupAttachment
                                      typeDetail="single"
                                      upload="PDF"
                                      typeUpload="PDF"
                                      prefixName="corporate-governance"
                                      label="PDF"
                                      required={true}
                                      description="description"
                                      widthSize={576}
                                      heightSize={721}
                                      value={validation.values.contentFile}
                                      onChange={(value = {}, index) => {
                                        console.log("🚀 onChange ~ value:", value)
                                        console.log("🚀 onChange ~ index:", index)
                                        validation.setFieldValue('contentFile', value)
                                      }}
                                      onRemove={(index) => {
                                        console.log("🚀 onChange ~ index:", index)
                                        validation.setFieldValue('contentFile', {})
                                      }}
                                    />
                                    {validation.touched.contentFile && validation.errors.contentFile && (
                                      <div type="invalid"className="invalid-feedback d-block">
                                        {validation.errors.contentFile}
                                      </div>
                                    )}
                                  </div>
                                  <hr/>
                                </Col>
                              </Row>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col className="col-4">
                            <Card outline color="primary" className="border sticky-element">
                                <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                                  <i className='bx bx-check'></i> Tools Box
                                </h5>
                                <CardBody>
                                  <Row>
                                    <Col className="col-12 mb-3">
                                      <label
                                        htmlFor="category_name"
                                        className="col-md-12 col-form-label"
                                      >
                                        Switch Language
                                        <span className="t-require">*</span>
                                      </label>
                                      <div className="col-md-12">
                                        <InputLang widthfull pageView={pageView} forceRoute={false}/>
                                      </div>
                                    </Col>
                                    <Col className="col-12 mb-3">
                                      <label
                                        htmlFor="category_name"
                                        className="col-md-12 col-form-label"
                                      >
                                        Written at
                                        <span className="t-require">*</span>
                                      </label>
                                      <div className="col-md-12">
                                        <InputGroup>
                                          <Flatpickr
                                            className="form-control d-block"
                                            options={{
                                              dateFormat: 'd/m/Y', // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                            }}
                                            value={validation.values.contentUpdateDate  ?moment(validation.values.contentUpdateDate, 'YYYY-MM-DD').toDate() : null}
                                            disabled={true}
                                          />
                                          <div className="input-group-append">
                                            <button
                                              type="button"
                                              className="btn btn-outline-secondary docs-datepicker-trigger"
                                              disabled
                                            >
                                              <i className="fa fa-calendar" aria-hidden="true"/>
                                            </button>
                                          </div>
                                        </InputGroup>
                                        {
                                          (validation.touched.contentUpdateDate && validation.errors.contentUpdateDate) && (
                                            <div type="invalid" className="invalid-feedback d-block">{validation.errors.contentUpdateDate}</div>
                                          )
                                        }
                                      </div>
                                    </Col>
                                    <Col className="col-12 mb-3">
                                      <label
                                        htmlFor="category_name"
                                        className="col-md-12 col-form-label"
                                      >
                                        Display
                                        <span className="t-require">*</span>
                                      </label>
                                      <div className="col-md-12">
                                        <Select
                                          placeholder="Select Status"
                                          value={fn_helper.FNFORM.getObjectValue(STATUS_OPTION, `${validation.values.contentStatus}`)}
                                          onChange={(value) => validation.setFieldValue("contentStatus", value.id)}
                                          getOptionValue={(option) => option.id}
                                          getOptionLabel={(option) => option.name}
                                          options={STATUS_OPTION}
                                          className={`select2-selection ${validation.touched.contentStatus && validation.errors.contentStatus ? "input-err" : ""}` }
                                          isDisabled={pageView === "view"}
                                        />
                                        {
                                          (validation.touched.contentStatus && validation.errors.contentStatus) && (
                                            <div type="invalid" className="invalid-feedback d-block">{validation.errors.contentStatus}</div>
                                          )
                                        }
                                      </div>
                                    </Col>
                                  </Row>
                                </CardBody>
                                <CardFooter>
                                  <Row>
                                      <Col className="text-start">
                                          <Button color="danger" className="btn btn-danger" onClick={() => navigate(`/corporate-governance/${qLang}/file`)}>Back</Button> 
                                      </Col>
                                      <Col className="text-end">
                                        {pageView !== 'view' && (<Button type="submit" className="btn btn-success">Save</Button>)}
                                      </Col>
                                  </Row>
                                </CardFooter>
                            </Card>
                          </Col>
                      </Row>
                    </Form>
                  </FormikProvider>
                  </Col>
                </Row>
            </Container>
          </div>
      </React.Fragment>
  )
}

// QuestionaireCategory.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(CorporateGovernanceFileTemplate)
